import { useState } from "react";
import FocusLock from "react-focus-lock";
import clsx from "clsx";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { Button, Icon } from "@/shared/ui";

type Props = {
  currMethod: TfaMethod | null;
  onChangeMethod: (method: TfaMethod) => void;
  enableMethods: TfaMethod[];
};

const RESET_METHODS = [
  {
    type: TfaMethod.AUTHENTICATOR,
    icon: "authenticator",
    title: "Authenticator",
    description: "Смена пароля через Authentificator",
  },
  {
    type: TfaMethod.EMAIL,
    icon: "mail",
    title: "E-mail",
    description: "Смена пароля через почту",
  },
  {
    type: TfaMethod.SMS,
    icon: "phone",
    title: "SMS",
    description: "Смена пароля через SMS",
  },
];

export default function PlayerMenuSettingsSafetyMethodForChangingPassword({
  currMethod,
  onChangeMethod,
  enableMethods,
}: Props) {
  const [selectedMethod, setSelectedMethod] = useState<TfaMethod | null>(currMethod);

  return (
    <FocusLock className="contents">
      <div className="gap-3 grow flex flex-col h-full">
        <div>Выберите способ смены пароля:</div>
        {RESET_METHODS.map((method) => (
          <Button
            key={method.type}
            variant={selectedMethod === method.type ? "solid-surface-gradient" : "soft"}
            color={selectedMethod === method.type ? "accent" : "gray"}
            className={clsx(
              "justify-start px-5 gap-5 text-left h-20 normal-case text-base font-medium",
              enableMethods.includes(method.type) ? "" : "brightness-50 pointer-events-none",
            )}
            onClick={() => setSelectedMethod(method.type)}
          >
            <Icon name={method.icon} className="w-7 text-white" />
            <div>
              <div className="text-white">{method.title}</div>
              <div className="text-sm">{method.description}</div>
            </div>
          </Button>
        ))}
        <Button
          type="button"
          onClick={() => onChangeMethod(selectedMethod)}
          className="w-full mt-auto"
          disabled={!selectedMethod}
        >
          Далее
        </Button>
      </div>
    </FocusLock>
  );
}
